<script setup lang="ts">
import type { BOCItem } from '../composables/useBOC'
import BOCRow from './BOCRow.vue'

defineProps<{
  active: BOCItem[]
  recent: BOCItem[]
  now: Date
}>()

const emit = defineEmits<{
  dismiss: [item: BOCItem]
}>()

const { t } = useI18n()
</script>

<template>
  <div class="flex w-96 max-w-[calc(100vw-3rem)] flex-col">
    <header class="border-b border-gray-200 px-4 py-3 dark:border-gray-800">
      <h3 class="text-sm font-semibold text-gray-900 dark:text-gray-100">
        {{ t('operations.boc.title') }}
      </h3>
    </header>

    <div class="max-h-96 overflow-y-auto py-1">
      <template v-if="active.length > 0">
        <p class="px-4 pb-1 pt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
          {{ t('operations.boc.activeHeading') }}
        </p>
        <div class="px-1">
          <BOCRow
            v-for="item in active"
            :key="item.id"
            :item="item"
            :now="now"
            @dismiss="emit('dismiss', $event)"
          />
        </div>
      </template>

      <div
        v-if="active.length > 0 && recent.length > 0"
        class="mx-4 my-1 border-t border-gray-100 dark:border-gray-800"
      />

      <template v-if="recent.length > 0">
        <p class="px-4 pb-1 pt-2 text-[0.65rem] font-semibold uppercase tracking-wide text-gray-400 dark:text-gray-500">
          {{ t('operations.boc.recentHeading') }}
        </p>
        <div class="px-1">
          <BOCRow
            v-for="item in recent"
            :key="item.id"
            :item="item"
            :now="now"
            @dismiss="emit('dismiss', $event)"
          />
        </div>
      </template>

      <div
        v-if="active.length === 0 && recent.length === 0"
        class="px-4 py-8 text-center text-sm text-gray-500 dark:text-gray-400"
      >
        {{ t('operations.boc.empty') }}
      </div>
    </div>
  </div>
</template>
